import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { getContentType, removeDefaultParams } from '../../../Utils/helper';
import AnywhereHorizontalScroll from '../../HelperComponents/AnywhereHorizontalScroll';
import {
  BannerTitle,
  GridWrapper,
} from '../../StoreHomePage/BannersGrid/styled';
import { RelativeDiv } from './styled';
import WeekCard from './WeekCard';
import { fireServedSectionEvent } from '../../../Utils/useFirebase';

export default function ParentingGrowthTracker(props) {
  const { data } = props;
  const router = useRouter();

  useEffect(() => {
    if (data?.items?.length > 0) {
      let cardId = [];
      data?.items?.forEach((element) => {
        cardId.push(element?.week);
      });
      fireServedSectionEvent(data?.heading, cardId, getContentType());
    }
  }, []);

  return (
    <GridWrapper>
      <BannerTitle>
        <h2>{data?.heading}</h2>
        <h3>{data?.subHeading}</h3>
      </BannerTitle>
      <RelativeDiv>
        <AnywhereHorizontalScroll
          firstElementId={`${data?.items[0]?.week}first`}
          lastElementId={`${data?.items[data?.items?.length - 1]?.week}last`}
          leftArrow={
            <img src={images.arrowDownForward} alt="arrow" loading="lazy" />
          }
          rightArrow={
            <img src={images.arrowDownForward} alt="arrow" loading="lazy" />
          }
          scrolledWidth={440}
        >
          {data?.items?.map((element, index) => {
            return (
              <Link
                href={{
                  pathname: `/parenting/pregnancy/week-${element?.week}`,
                  query: removeDefaultParams(router.query),
                }}
                passHref
                key={index}
              >
                <WeekCard
                  itemId={`element-${index}`}
                  key={`element-${index}`}
                  weekData={element}
                  sectionId={element?.week}
                  index={index}
                  length={data?.items?.length}
                  heading={data?.heading}
                />
              </Link>
            );
          })}
        </AnywhereHorizontalScroll>
      </RelativeDiv>
    </GridWrapper>
  );
}
